<script lang="ts" setup>
import { createPoint } from "@p-v/utils/factory"
import { inject, onUnmounted, ref, watch } from "vue"
import MapMarkerPng from "@p-v/asset/image/map-mark-1.png"
import type { Point } from "@p-v/packages/Map/map"

interface ComponentProps {
  point: Point
  title: string
  backgroundImage?: string
  opacity?: number
  offsetY?: number
  offsetX?: number
  gpsType?: "GCJ02" | "BD09"
}

const props = withDefaults(defineProps<ComponentProps>(), {
  point: () => ({ lng: 116.40342230333138, lat: 39.92498414216742 }),
  title: () => "",
  backgroundImage: () => "",
  opacity: () => 0.5,
  offsetY: () => 0,
  offsetX: () => 0,
  gpsType: () => "BD09",
})

const bmap = inject("bmap") as any

function GCJ02toBD09(lng: number, lat: number) {
  // 3.14159265358979324
  let x_pi = (3.141592653589793 * 3000.0) / 180.0
  let x = lng
  let y = lat
  let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi)
  let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi)
  let lngs = z * Math.cos(theta) + 0.0064
  let lats = z * Math.sin(theta) + 0.0064
  return {
    lng: lngs,
    lat: lats,
  }
}

const createDOM = () => {
  const div = document.createElement("div")
  div.style.cssText = `
    position: absolute;
    width: 50px;
    height: 60px;
    background-image: url(${props.backgroundImage ? props.backgroundImage : MapMarkerPng});
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: top;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    font-size: 14px;
    color: #fff;
    text-align: center;
  `

  const title = document.createElement("span")
  title.style.display = "block"
  title.style.lineHeight = "16px"
  title.style.fontSize = "12px"
  title.style.fontWeight = "700"
  title.style.width = "50px"
  // 内容超出宽度自动省略
  title.style.overflow = "hidden"
  title.style.textOverflow = "ellipsis"
  title.style.whiteSpace = "nowrap"
  title.style.padding = "0 2px"
  title.innerHTML = props.title
  div.appendChild(title)
  return div
}

const overlay = ref<any>(undefined)
watch(
  () => bmap.value,
  value => {
    if (value && overlay.value === undefined) {
      const newPoint = props.gpsType === "GCJ02" ? GCJ02toBD09(props.point.lng, props.point.lat) : props.point
      overlay.value = new window.BMapGL.CustomOverlay(createDOM, {
        point: createPoint(window.BMapGL, newPoint),
        opacity: props.opacity,
        offsetY: props.offsetY,
        offsetX: props.offsetX,
      })
      bmap.value?.addOverlay(overlay.value)
    }
  },
  { immediate: true },
)

onUnmounted(() => {
  bmap.value?.removeOverlay(overlay.value)
})
</script>
